export const AMOUNT = 'AMOUNT';
export const COUNT = 'COUNT';
export const ALL = 'ALL';

export const statusDesc = [
  { id: 1, description: 'Deposited' },
  { id: 10, description: 'Refunded' },
  { id: 2, description: 'Returned' }
];

export const defaultCurrency = { id: 840, code: 'USD', description: 'US Dollar' };
